import { render, staticRenderFns } from "./affiliate.vue?vue&type=template&id=3bb6a39e&scoped=true"
import script from "./affiliate.vue?vue&type=script&lang=js"
export * from "./affiliate.vue?vue&type=script&lang=js"
import style0 from "./affiliate.vue?vue&type=style&index=0&id=3bb6a39e&prod&scoped=true&lang=css"
import style1 from "./affiliate.vue?vue&type=style&index=1&id=3bb6a39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6a39e",
  null
  
)

export default component.exports